module.exports = __webpack_public_path__ + "img/首图@3x.1ef12cfe.png";